"use strict";
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var React = tslib_1.__importStar(require("react"));
var common_1 = require("../../common");
/**
 * Dialog footer component.
 *
 * @see https://blueprintjs.com/docs/#core/components/dialog.dialog-footer-props
 */
var DialogFooter = function (props) {
    var _a;
    var actions = props.actions, children = props.children, className = props.className, _b = props.minimal, minimal = _b === void 0 ? false : _b, htmlProps = tslib_1.__rest(props, ["actions", "children", "className", "minimal"]);
    return (React.createElement("div", tslib_1.__assign({}, htmlProps, { className: (0, classnames_1.default)(common_1.Classes.DIALOG_FOOTER, className, (_a = {},
            _a[common_1.Classes.DIALOG_FOOTER_FIXED] = !minimal,
            _a)) }),
        React.createElement("div", { className: common_1.Classes.DIALOG_FOOTER_MAIN_SECTION }, children),
        actions != null && React.createElement("div", { className: common_1.Classes.DIALOG_FOOTER_ACTIONS }, actions)));
};
exports.DialogFooter = DialogFooter;
exports.DialogFooter.displayName = "".concat(common_1.DISPLAYNAME_PREFIX, ".DialogFooter");
//# sourceMappingURL=dialogFooter.js.map